module.exports = __webpack_public_path__ + "static/media/imagem-localizacao.4e2de1b3.jpg";